import { useFormik } from 'formik';
import { snakeCase } from 'lodash';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Modal from 'react-responsive-modal';
import { addField } from 'redux/actions';
import { getFields } from 'redux/selectors';
import uniqid from 'uniqid';
import * as Yup from 'yup';

const CreateGroupModal = ({ open, onClose }) => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const fields = useSelector((state) => getFields(state));
  const formik = useFormik({
    initialValues: {
      name: ''
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .max(256, 'Must be 256 characters or less')
        .required('Required')
    }),
    onSubmit: (values) => {
      const field = {
        geometry: { page: 1 },
        data: {
          type: 'group',
          name: snakeCase(values.name),
          label: values.name,
          description: '',
          id: uniqid(),
          fields: []
        }
      };
      dispatch(addField(field));
      onClose();
    }
  });
  return (
    <Modal open={open} onClose={onClose} closeOnOverlayClick={false}>
      <div class="modal_top">
        <h3 class="title is-h3">Add a Field Group</h3>
        <form onSubmit={formik.handleSubmit}>
          <div class="field">
            <div class="control">
              <input
                class="input is-small"
                type="text"
                name="name"
                placeholder="Field group name..."
                value={formik.values.name}
                onChange={formik.handleChange}
              />
            </div>
            {formik.errors.name && (
              <p class="help is-danger">{formik.errors.name}</p>
            )}
          </div>
          <hr />
          <div class="field is-grouped">
            <div class="control">
              <button
                type="submit"
                class={`button is-info is-small ${loading ? 'is-loading' : ''}`}
              >
                Add Group
              </button>
            </div>
            <div class="control">
              <button
                type="button"
                onClick={onClose}
                class="button is-info is-small is-light"
              >
                Cancel
              </button>
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export const GroupField = (props) => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <>
      <CreateGroupModal
        open={modalOpen}
        onClose={() => {
          setModalOpen(false);
        }}
      />

      <p class="control">
        <button
          type="button"
          class={`button is-small`}
          onClick={(e) => {
            setModalOpen(true);
          }}
        >
          <span class="icon is-small">
            <i class="fa fa-link"></i>
          </span>
          <span>Group</span>
        </button>
      </p>
    </>
  );
};
